// Shared types for archetype components. The CompoundStep host passes
// each archetype a uniform prop bundle; individual components
// destructure only what they need. Keeping a single prop bundle keeps
// the dispatch table in CompoundStep declarative.
/** Narrow `config[key]` to a string with a fallback. */
export function s(config, key, fallback = '') {
    const v = config[key];
    return typeof v === 'string' ? v : fallback;
}
/** Narrow `config[key]` to a boolean with a fallback. */
export function b(config, key, fallback = false) {
    const v = config[key];
    return typeof v === 'boolean' ? v : fallback;
}
